import { render, staticRenderFns } from "./CharacterForm.vue?vue&type=template&id=495c0ecd&scoped=true"
import script from "./CharacterForm.vue?vue&type=script&lang=ts"
export * from "./CharacterForm.vue?vue&type=script&lang=ts"
import style0 from "./CharacterForm.vue?vue&type=style&index=0&id=495c0ecd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495c0ecd",
  null
  
)

export default component.exports